import React from "react"
import PropTypes from "prop-types"
import Login from "./steps/Login"
import Register from "./steps/Register"
import Forgot from "./steps/Forgot"
import Reset from "./steps/Reset"
import User from "models/user"

const Authentication = ({ step, onSubmitLogin, onSubmitRegister, onSubmitForgot, onSubmitReset, user, children }) => {
  const [activeStep, setActiveStep] = React.useState(step)

  if (user?.isLoggedIn()) {
    return children || null
  }

  switch (activeStep) {
    case "login":
      return <Login onSubmit={onSubmitLogin} setActiveStep={setActiveStep} />

    case "register":
      return (
        <Register onSubmit={onSubmitRegister} setActiveStep={setActiveStep} />
      )

    case "forgot":
      return (
        <Forgot onSubmit={onSubmitForgot} setActiveStep={setActiveStep} />
      )

    case "reset":
      return (
        <Reset onSubmit={onSubmitReset} setActiveStep={setActiveStep} />
      )

    default:
      return null
  }
}

Authentication.propTypes = {
  step: PropTypes.oneOf(["login", "register", "forgot", "reset"]),
  onSubmitLogin: PropTypes.func,
  onSubmitRegister: PropTypes.func,
  onSubmitForgot: PropTypes.func,
  onSubmitReset: PropTypes.func,
  user: PropTypes.instanceOf(User).isRequired,
}

Authentication.defaultProps = {
  step: "login",
}

export { Authentication, Login }
